<template>


<div :class="['item_layout', { 'item_layout_choosen': item.isChoosen }]" @click="handleClick(item.index)">

<div class="item_layout_left">
  <img class="item_layout_pic" :src="item.src" />
  
</div>
<div class="item_layout_right">
  <span class="function_name">{{ item.name }}</span>
  <span class="function_expend"

  :style="{ 
    // backgroundColor: currentEquipmentStatus === 0  ? '' : '#9da3a3',

    color: item.status == 1  ? '#9da3a3' : ''
  
  }"
  
  >{{ item.expend }}</span>
  
</div>

<img class="choosen_pic" v-show="item.isChoosen" :src="require('@/assets/choosen.png')" />

</div>


  

  
 



  
  

  
    
  </template>
  
  <script>
  export default {
    name: 'FunctionItemLayout',

    props: {
    item: {
      type: Object,
      required: true
    }
  },
  
   
  
    methods: {
      // 在这里添加你的方法
      handleClick(id) {
      this.$emit('send-message-to-android',id);
    }
    }
  };
  </script>
  
  <style scoped>

    
.item_layout {
    flex: 1;
    border: 0.08rem solid grey;
    
    border-radius: 0.17rem;
    
    text-align: center;
    border: 0.1rem solid grey;
    
    
    
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
    height: 2rem;
    flex-direction: column;
    margin-left: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative; /* 使右下角图片定位相对于这个容器 */
   
  }

  .item_layout_choosen {
    border: 0.1rem solid #1296db;
}



  .item_layout_left{
    flex: 1;
    
    align-items: center;
    justify-content: center;

  }

  .item_layout_pic{

    width:0.8rem; 
    margin-top: 0.2rem;

  }


  .item_layout_right{
    flex: 1.5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
  }
  .function_name {
    text-align: center;
    font-size: 0.6rem;  
    margin-bottom: 0.1rem;

 
  }




  .function_expend {
    text-align: center;
    font-size: 0.4rem;
    color: red;
  } 


  .choosen_pic {
  position: absolute;
  bottom: -0.08rem;
  right: -0.08rem;
  width: 1.1rem; /* 根据需要调整大小 */
  height: 1.1rem; /* 根据需要调整大小 */
  border-radius: 0 0 0.17rem 0; /* 右下角圆角 */
  
  
}

  
  </style>